import BaseNewIcon from "../../img/icons/new.svg?react";
import BaseSameIcon from "../../img/icons/same.svg?react";
import styled from "styled-components";
import { size } from "polished";

export const NewIcon = styled(BaseNewIcon)`
  ${size(12)}
  fill: ${({ theme }) => theme.colors.greyDarker3};
`;

export const SameIcon = styled(BaseSameIcon)`
  ${size(10)}
  fill: ${({ theme }) => theme.colors.greyDarker3};
`;
